import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, Fields, formValueSelector } from "redux-form";
import { COMPANY_ID, CONTACT_ID, NAME } from "APP_ROOT/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import {
  FormInput,
  PhoneNumberField,
  Select
} from "MODULES/shared/components/Forms";
import { contactSelectList } from "MODULES/companies/helpers";
import { PORTAL_PURCHASE } from "MODULES/PurchaseOrders/constants";
import { properCase } from "LIB/formatters/text";
import { CONTACT, WEBSITE } from "MODULES/companies/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import RestrictedContactWarning from "MODULES/companies/shared/components/RestrictedContactWarning";
import SearchCompanyField from "./SearchCompanyField";

export function SearchCompany(props) {
  const {
    allowPortalPurchase,
    contact,
    contacts,
    fetchContacts,
    getFieldValue,
    onCompanySelected,
    selectedCompany,
    companySearch,
    handleEmail,
    type = "default",
    disabledFields = {}
  } = props;
  const addContact = contact === "Add";
  const portalPurchase = contact === PORTAL_PURCHASE;
  const options = contactSelectList(contacts, allowPortalPurchase);

  const [selectedContact, setSelectedContact] = useState(null);

  const handleCompanySelected = result => {
    onCompanySelected(result);
    fetchContacts(result.id);
  };

  const findContactEmail = e => {
    const contactEmail = contacts.find(x => x.id === Number(e.target.value));
    if (contactEmail && handleEmail) {
      handleEmail(contactEmail.email);
    }
  };

  const newEmail = e => {
    if (handleEmail) {
      handleEmail(e.target.value);
    }
  };

  const contactName =
    contact === "Add" && getFieldValue([CONTACT, NAME].join("."))
      ? getFieldValue([CONTACT, NAME].join("."))
      : selectedContact && selectedContact.name;

  return (
    <div>
      <FormRow>
        <Col md={6}>
          <Fields
            autoFocus
            names={[COMPANY_ID, CONTACT_ID]}
            component={SearchCompanyField}
            companySearch={companySearch}
            onResultSelected={handleCompanySelected}
            selectedCompany={selectedCompany}
            placeholder="Search by typing a company's name or code"
            type={type}
            required
            disabled={disabledFields.company_id}
          />
        </Col>
        <Col md={6}>
          <div className="form-group">
            <Field
              name={CONTACT_ID}
              component={Select}
              options={options}
              label="Contact"
              onChange={e => {
                props.clearNewContact && props.clearNewContact();
                findContactEmail(e);
                setSelectedContact(e.target.value);
              }}
              required
              disabled={disabledFields.contact_id}
            />
          </div>
        </Col>
      </FormRow>
      {portalPurchase && (
        <FormRow>
          <Col md={4}>
            <div className="form-group">
              <Field
                component={FormInput}
                disabled={selectedCompany && selectedCompany.website}
                name="company.website"
                label={properCase(WEBSITE)}
                required
              />
            </div>
          </Col>
        </FormRow>
      )}

      {addContact && (
        <FormRow>
          <Col md={4}>
            <div className="form-group">
              <Field
                name="contact.name"
                component={FormInput}
                label="Contact Name"
                required
              />
            </div>
          </Col>
          <Col md={4}>
            <div className="form-group">
              <Field
                name="contact.email"
                component={FormInput}
                label="Contact Email"
                onChange={newEmail}
                required
              />
            </div>
          </Col>
          <Col md={4}>
            <PhoneNumberField
              name="contact.phone1"
              component={FormInput}
              label="Phone Number 1"
              type="tel"
            />
          </Col>
        </FormRow>
      )}
      <FormRow>
        <Col md={12}>
          <RestrictedContactWarning contact={contactName} />
        </Col>
      </FormRow>
    </div>
  );
}

SearchCompany.propTypes = {
  allowPortalPurchase: PropTypes.bool,
  contact: PropTypes.string,
  fetchContacts: PropTypes.func.isRequired,
  onCompanySelected: PropTypes.func.isRequired,
  selectedCompany: PropTypes.shape({}),
  contacts: PropTypes.arrayOf(PropTypes.shape({})),
  companySearch: PropTypes.func,
  type: PropTypes.string,
  handleEmail: PropTypes.func,
  disabledFields: PropTypes.shape({})
};

const selector = (form, ...other) => formValueSelector(form)(...other);

export default connect((state, ownProps) => ({
  contact: selector(ownProps.formName, state, CONTACT_ID)
}))(withFieldAccessors(SearchCompany));



// WEBPACK FOOTER //
// ./app/modules/companies/shared/FindOrCreateCompanyToggle/SearchCompany.jsx